var render, staticRenderFns
import script from "./RewardSetting.vue?vue&type=script&lang=js"
export * from "./RewardSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19017a9e",
  null
  
)

export default component.exports